export const getEndOfDay = (d) => {
  const date = new Date(d);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return new Date(`${year}-${month}-${day} 23:59:59`);
};

export const getStartOfDay = (d) => {
  const date = new Date(d);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return new Date(`${year}-${month}-${day} 00:00:00`);
};

export const getNextDay = (d) => {
  const date = new Date(d);
  date.setDate(date.getDate() + 1);
  return getStartOfDay(date);
};

export const isValidPeriod = (date1, date2) => {
  return new Date(date1).getTime() < new Date(date2).getTime();
};

export const isFutureDate = (date) => {
  return new Date(date).getTime() > new Date().getTime();
};

export const isTomorrowOrLaterDate = (d) => {
  const endOfToday = getEndOfDay(new Date());
  const date = new Date(d);
  return date.getTime() > endOfToday.getTime();
};

export const formatDate = (date, format = "YYYY.MM.DD. hh:mm:ss") => {
  const buildTwoChar = (text) => {
    if (text.length < 2) {
      text = "0" + text;
    }
    return text;
  };

  const year = date.getFullYear();
  const month = buildTwoChar("" + (date.getMonth() + 1));
  const day = buildTwoChar("" + date.getDate());
  const hours = buildTwoChar("" + date.getHours());
  const minutes = buildTwoChar("" + date.getMinutes());
  const seconds = buildTwoChar("" + date.getSeconds());

  return format
    .replace("YYYY", year)
    .replace("MM", month)
    .replace("DD", day)
    .replace("hh", hours)
    .replace("mm", minutes)
    .replace("ss", seconds);
};
